import MasteryPage from "./MasteryPage";

export default MasteryPage;